import { Component,OnInit, Input} from '@angular/core';
import { NbDialogRef, NbDialogService, NbThemeService } from '@nebular/theme';
import { ApiService } from './../../shared/api.service';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { config } from '../../../../config.prod';
import {ConfirmationService} from 'primeng/api';
import { readApplyToken } from '../../shared/apply-token.interceptor';

@Component({
    selector: 'nb-dialog',
    template: 
    `
    <nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="xlarge">
        <nb-card-header>ATKT Marksheet</nb-card-header>
            <nb-card-body>
                <div class="row">
                <div class="col-xl-12" style='center;'>
                    <b>Enter Marksheet name (e.g. sem1-atkt,sem2-atkt.....)</b>
                    <input type="text" class="form-control" (input)="onSearchChange($event.target.value)" [(ngModel)]="reason" name='inputTranscriptName' id="inputTranscriptName" placeholder="Enter Marksheet Name">
                </div><br><br><br>
                    
                </div>
                <span *ngIf='uploaderror == true' style="color:red; font-size: medium;">Max uploaded file size should be 5 MB.</span>
            </nb-card-body>
        <nb-card-footer>
            <div class="row">
              <div class="col-md-2">
                <button nbButton hero status="primary" (click)="dismiss()">Close</button>
              </div> 
            <div class="col-md-2"></div>
              <div class="col-md-2" style="padding-top: 1%;">
                <p-fileUpload *ngIf="showUpload == true" ngDefaultControl [accept]="'.jpg,.jpeg,.png,.pdf,.PNG,.JPEG,.JPG,.PDF'" mode="basic" auto="true"
                    chooseLabel="Upload" name="file" url="{{transUploadUrl}}?user_id={{user_id}}&&transcript_name={{reason}}&&hiddentype=atkt_Marsheet&&applyToken={{applyToken}}"
                    maxFileSize="5000000"
                    (onBeforeSend)="onBeforeSend($event)"
                    (onUpload)="onUpload($event)"
                    (onSelect)="onSelect($event)"
                    (onError)="onErrorFileUpload($event)">
                </p-fileUpload>
              </div>         
            </div>           
        </nb-card-footer>
    </nb-card>
    `,
    providers:[ConfirmationService],
    })
    export class TranscriptDialogComponent implements OnInit {
        @Input() user_id: any;
        cbse_marks;
        currenttoken;
        showUpload;
        loading = false;
        reason;
        uploaderror = false;
        uploaderror1 = false;
        transUploadUrl = config.docUploadUrl;
        // PrimeNG posts a bare form with no headers, so the /apply token rides in the URL.
        applyToken = readApplyToken();
      
        constructor(
          protected ref: NbDialogRef<TranscriptDialogComponent>,
          protected api : ApiService,
          private authService: NbAuthService,
          public themeService : NbThemeService,
          private confirmationService: ConfirmationService,
          private dialogService: NbDialogService,
          ) 
          {
            
          }
        
          dismiss() {
          this.ref.close();
          }
        
          onBeforeSend(event) {
            this.loading = true;
            this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
              if (token.isValid()) {
               this.currenttoken = token;
                event.xhr.setRequestHeader("Authorization", `Bearer ` +this.currenttoken);
                event.formData.append('token',''+this.currenttoken);
                }
            });
          }
          
          onUpload(event) {
              const reader = new FileReader();
              if(event.files && event.files.length) {
                const [file] = event.files;
                reader.readAsDataURL(file);
                this.loading = false;
                
                this.ref.close(file);
              }
          
          }
          
        
          onSelect($event: any): void {
                var maxFileSize =  5000000;
                var imgArr = $event.files[0].name.split('.');
            var extension = imgArr[imgArr.length - 1].trim();
            
            if(extension!='jpg' && extension!='jpeg' && extension!='png' && extension!='pdf'){
                    this.uploaderror1 = true;
            }
            
            if ($event.files[0].size > maxFileSize) {
              this.uploaderror = true;
              this.confirmationService.confirm({
                        message: 'Maximum file size should be 5 MB.',
                        header: 'Invalid File Size',
                        icon: 'pi pi-info-circle',
                        rejectVisible : false,
                        acceptLabel: 'Ok'
                    });
            }
        
            
          }
        
        
          ngOnInit() {
            this.showUpload = false;
           }

           onSearchChange(searchValue : string ) {
            if(searchValue.length > 0){
              this.showUpload = true;
            }else{
              this.showUpload = false;
            }
            
          }
          
    }
        